import $ from "jquery";

const CONTAINER_SELECTOR = '[data-interactive-form]';
const FORM_SELECTOR = '[data-interactive-form-state-initial]';
const LOADING_SELECTOR = '[data-interactive-form-state-loading]';
const ERROR_SELECTOR = '[data-interactive-form-state-error]';
const SUCCESS_SELECTOR = '[data-interactive-form-state-success]';
const RESET_STATE_SELECTOR = '[data-interactive-form-reset]';

const STATE_INITIAL = 'initial';
const STATE_LOADING = 'loading';
const STATE_SUCCESS = 'success';
const STATE_ERROR = 'error';

const FORM_ACTION_ATTR = 'action';
const REDIRECT_FLAG = 'redirect';

export default class Form {
    constructor() {
        this.setupEvents();
    }
    
    setupEvents() {
        $(FORM_SELECTOR).on('submit', (ev) => {
            ev.preventDefault();
            
            this.handleFormSubmit(ev);
        })

        $('body').on('click', RESET_STATE_SELECTOR, (ev) => {
            ev.preventDefault();
            const $target = $(ev.currentTarget);
            const $container = $target.closest(CONTAINER_SELECTOR);
            this.setState($container, STATE_INITIAL);
        })
    }

    async handleFormSubmit(ev) {
        let postSuccess = false;
        const $form = $(ev.currentTarget);
        const $container = $form.closest(CONTAINER_SELECTOR);
        const formData = $form.serializeArray();
        const postUrl = $form.attr(FORM_ACTION_ATTR);
        const postData = formData.reduce((data, keyPair) => {
            if (keyPair.name === REDIRECT_FLAG) {
                return data;
            }
            data[keyPair.name] = keyPair.value;
            return data;
        }, {})
        
        this.setState($container, STATE_LOADING)

        try {
            const response = await fetch(
                postUrl,
                {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: $.param(postData)
                }
            );
            const result = await response.json();
            postSuccess = response.status < 400 && result.success;
        } catch(e) {
            console.log(e);
            postSuccess = false;
        }

        if (postSuccess) {
            this.setState($container, STATE_SUCCESS);
        } else {
            this.setState($container, STATE_ERROR);
        }
    }
    
    setState($container, state = STATE_INITIAL) {
        const views = [];
        views[STATE_LOADING] = $container.find(LOADING_SELECTOR);
        views[STATE_SUCCESS] = $container.find(SUCCESS_SELECTOR);
        views[STATE_ERROR] = $container.find(ERROR_SELECTOR);

        Object.keys(views).forEach(stateView => {
            const $view = views[stateView];
            $view.attr('aria-hidden', true);
            
            if (stateView === state) {
                $view.attr('aria-hidden', false);
            }
        });
    }


}



// WEBPACK FOOTER //
// ./assets/scripts/front/App/Forms/InteractiveForm.js